(() => {
  if (window.__jrmFeatureTrackingInitialized) return;
  window.__jrmFeatureTrackingInitialized = true;

  const GA4_ID = 'G-QD6BSN3VJY';
  const pendingWishlistAdds = new Map();
  let pendingQuickView = null;
  let pendingContactOpen = null;

  const send = (eventName, params = {}) => {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', eventName, { ...params, send_to: GA4_ID });
  };

  const collectionHandle = () => {
    const match = window.location.pathname.match(/^\/collections\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const productHandle = () => {
    const match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const pageType = () => {
    const prefix = 'hdt-page-type-';
    const className = Array.from(document.body?.classList || []).find((name) => name.startsWith(prefix));
    if (className) return className.slice(prefix.length);

    const path = window.location.pathname;
    if (path.startsWith('/products/')) return 'product';
    if (path.startsWith('/collections/')) return 'collection';
    if (path.startsWith('/blogs/')) return path.split('/').filter(Boolean).length > 2 ? 'article' : 'blog';
    if (path.startsWith('/pages/')) return 'page';
    if (path === '/search' || path.startsWith('/search/')) return 'search';
    if (path === '/') return 'index';
    return 'other';
  };

  const contactContext = () => ({
    interaction_surface: 'floating_contact_launcher',
    page_type: pageType(),
    product_handle: productHandle(),
    collection_handle: collectionHandle()
  });

  const surfaceFor = (element) => {
    if (!(element instanceof Element)) return 'other';
    if (element.closest('#hdt-quick-view-modal')) return 'quick_view';
    if (element.closest('#hdt-quick-add-modal')) return 'quick_add';
    if (element.closest('hdt-card-product')) return 'product_card';
    if (window.location.pathname.startsWith('/products/')) return 'product_page';
    return 'other';
  };

  const captureWishlistIntent = (event) => {
    if (event.type === 'keydown' && event.key !== 'Enter') return;
    const origin = event.target instanceof Element ? event.target : null;
    const button = origin?.closest('hdt-wishlist[action="add"]');
    if (!button) return;

    const productId = button.getAttribute('data-id') || '';
    if (!productId) return;

    pendingWishlistAdds.set(productId, {
      element: button,
      productHandle: button.getAttribute('data-handle') || '',
      surface: surfaceFor(button),
      timestamp: Date.now()
    });
  };

  const flushWishlistAdds = () => {
    const now = Date.now();

    for (const [productId, pending] of pendingWishlistAdds) {
      if (now - pending.timestamp > 15000) {
        pendingWishlistAdds.delete(productId);
        continue;
      }

      const action = pending.element?.getAttribute('action');
      if (!action || action === 'add') continue;

      send('add_to_wishlist', {
        items: [{ item_id: String(productId) }],
        product_handle: pending.productHandle,
        interaction_surface: pending.surface,
        collection_handle: collectionHandle()
      });

      pendingWishlistAdds.delete(productId);
    }
  };

  const captureQuickViewIntent = (event) => {
    const origin = event.target instanceof Element ? event.target : null;
    const button = origin?.closest('.hdt-card-product__btn-quick-view[aria-controls="hdt-quick-view-modal"]');
    if (!button) return;

    pendingQuickView = {
      productHandle: button.getAttribute('handle') || button.getAttribute('data-handle') || '',
      timestamp: Date.now()
    };
  };

  const onDialogOpen = (event) => {
    const modal = event.target instanceof Element ? event.target : null;
    if (!modal || modal.id !== 'hdt-quick-view-modal') return;

    const opener = modal.btnOpening instanceof Element ? modal.btnOpening : null;
    const pendingIsFresh = pendingQuickView && Date.now() - pendingQuickView.timestamp < 15000;
    const currentProductHandle =
      opener?.getAttribute('handle') ||
      opener?.getAttribute('data-handle') ||
      (pendingIsFresh ? pendingQuickView.productHandle : '') ||
      '';

    send('quick_view_open', {
      product_handle: currentProductHandle,
      interaction_surface: 'product_card',
      collection_handle: collectionHandle()
    });

    pendingQuickView = null;
  };

  const onCartUpdate = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const detail = event.detail || {};
    if (detail.source !== 'product-form-component') return;

    const inQuickAddModal = Boolean(target.closest('#hdt-quick-add-modal'));
    const inProductCard = Boolean(target.closest('hdt-card-product'));
    if (!inQuickAddModal && !inProductCard) return;

    const data = detail.data || {};

    send('quick_add_to_cart', {
      quick_add_mode: inQuickAddModal ? 'modal' : 'direct',
      product_id: data.productId != null ? String(data.productId) : '',
      variant_id: detail.sourceId != null ? String(detail.sourceId) : '',
      cart_source_id: detail.sourceId != null ? String(detail.sourceId) : '',
      collection_handle: collectionHandle()
    });
  };

  const captureContactOpenIntent = (event) => {
    const origin = event.target instanceof Element ? event.target : null;
    const launcher = origin?.closest('#JrmContactLauncher');
    if (!launcher) return;

    pendingContactOpen = { timestamp: Date.now() };
  };

  const onContactDialogOpen = (event) => {
    const modal = event.target instanceof Element ? event.target : null;
    if (!modal || modal.id !== 'JrmContactDialog') return;

    const pendingIsFresh = pendingContactOpen && Date.now() - pendingContactOpen.timestamp < 15000;
    if (!pendingIsFresh) {
      pendingContactOpen = null;
      return;
    }

    send('contact_form_open', contactContext());
    pendingContactOpen = null;
  };

  document.addEventListener('click', captureWishlistIntent, true);
  document.addEventListener('keydown', captureWishlistIntent, true);
  document.addEventListener('theme4:wishlist:update', flushWishlistAdds);

  document.addEventListener('click', captureQuickViewIntent, true);
  document.addEventListener('dialog:open', onDialogOpen, true);

  document.addEventListener('cart:update', onCartUpdate, true);

  document.addEventListener('click', captureContactOpenIntent, true);
  document.addEventListener('dialog:open', onContactDialogOpen, true);
})();
